import type { Brand } from "@health/types";
import { useEffect } from "react";

export function useBrandTheme(brand: Brand) {
  useEffect(() => {
    document.documentElement.setAttribute("data-brand", brand);
    return () => {
      document.documentElement.removeAttribute("data-brand");
    };
  }, [brand]);
}
